import localStorage from '@/utils/localStorage';
import router from '@this/router';
import sample from 'lodash/sample';
import { getJson } from '@this/services/car';
const state = {
  seriesIndex: 0,
  currentCarList: [],
  currentImages: [],
  cpList: [],
  currentCar: {},
  id: '',
  brands: {},
};

const mutations = {
  setSeriesIndex(state, index) {
    state.seriesIndex = index;
  },
  setCurrentCarList(state, list) {
    state.currentCarList = list;
  },
  setCurrentCar(state, info) {
    state.currentCar = info;
  },
  setCurrentImages(state, list) {
    state.currentImages = list;
  },
  setId(state, string) {
    state.id = string;
  },
  setBrands(state, obj) {
    state.brands = obj;
  },
};

const actions = {
  async findCurrentBrand({ commit, state, dispatch, rootState }) {
    const { id } = router.currentRoute.query;
    const brandList = rootState.config.allBrandList;
    const currentBrand = brandList.find((item) => item.id == id);
    commit('setBrands', currentBrand);
  },
  async getJson({ commit, state, dispatch }) {
    await getJson(state.brands.show_url).then((data) => {
      commit('setCurrentCarList', data);
      commit('setSeriesIndex', 0);
      dispatch('changeCarColor', state.seriesIndex);
    });
  },
  async changeCarColor({ state, commit, dispatch }, index) {
    commit('setSeriesIndex', index);
    commit('setCurrentCar', state.currentCarList[state.seriesIndex]);
    await dispatch('carImagesPreLoadAll');
  },
  async carImagesPreLoadAll({ state, commit }) {
    const { Hori } = state.currentCar;
    const images = Hori.Normal;
    const bigImages = images.map((res) => res.Url);
    commit('setCurrentImages', bigImages);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
